import { Component } from '@angular/core';

@Component({
  selector: 'app-solutions-landing',
  templateUrl: './solutions-landing.component.html',
  styleUrls: ['./solutions-landing.component.scss'],
  standalone: false
})
export class SolutionsLandingComponent {
  businessSolutions = [
    {
      title: 'Automotive OEM',
      subtitle: 'End-to-end connected vehicle programs for OEMs, from factory integration to lifecycle services.',
      icon: 'bx-car',
      route: '/solutions/business/automotive-oem'
    },
    {
      title: 'Fleet & Logistics',
      subtitle: 'Real-time fleet visibility, driver insights, and route intelligence for logistics operations.',
      icon: 'bx-transfer',
      route: '/solutions/business/fleet-logistics'
    },
    {
      title: 'Insurance (BFSI)',
      subtitle: 'Usage-based insurance enablement with telematics scoring, risk profiling, and claim support.',
      icon: 'bx-shield-quarter',
      route: '/solutions/business/insurance'
    },
    {
      title: 'Enterprise',
      subtitle: 'Scalable connected mobility infrastructure for enterprise operations, analytics, and automation.',
      icon: 'bx-building',
      route: '/solutions/business/enterprise'
    }
  ];

  consumerSolutions = [
    {
      title: 'Connected Car',
      subtitle: 'A unified connected driving experience with trip data, live vehicle health, and smart controls.',
      icon: 'bx-wifi',
      route: '/solutions/consumers/connected-car'
    },
    {
      title: 'Safety & Alerts',
      subtitle: 'Proactive safety notifications, emergency assistance, and behavior-based driver alerts in real time.',
      icon: 'bx-bell',
      route: '/solutions/consumers/safety-alerts'
    },
    {
      title: 'Rewards',
      subtitle: 'Earn and redeem rewards through driving behavior, milestones, and partner ecosystem benefits.',
      icon: 'bx-gift',
      route: '/solutions/consumers/rewards'
    },
    {
      title: 'Device Store',
      subtitle: 'Discover and purchase compatible connected devices that extend the in-vehicle digital experience.',
      icon: 'bx-store',
      route: '/solutions/consumers/device-store'
    }
  ];

  businessEcosystemCards = [
    {
      title: 'OEM Solutions',
      subtitle: 'Connected vehicle capabilities for manufacturers',
      icon: 'bx-car'
    },
    {
      title: 'Fleet Management',
      subtitle: 'Tracking, driver behavior, and operational efficiency',
      icon: 'bx-transfer'
    },
    {
      title: 'Insurance Telematics',
      subtitle: 'Usage-based insurance and driving risk insights',
      icon: 'bx-shield-quarter'
    },
    {
      title: 'IoT Solutions',
      subtitle: 'Smarter connected ecosystems beyond the vehicle',
      icon: 'bx-network-chart'
    }
  ];

  consumerEcosystemCards = [
    {
      title: 'Connected Experience',
      subtitle: 'Trip tracking, live insights, and digital journeys',
      icon: 'bx-wifi'
    },
    {
      title: 'Safety & Assistance',
      subtitle: 'Alerts, monitoring, and proactive support features',
      icon: 'bx-bell'
    },
    {
      title: 'Miles Rewards',
      subtitle: 'Drive, earn Miles, and redeem platform offers',
      icon: 'bx-gift'
    }
  ];
}
